import { useState } from "react";
import { Share2, Loader2, Copy, Check } from "lucide-react";
import { toast } from "sonner";
import { createShare } from "@/lib/api";

export function ShareButton({ result, profile }) {
  const [busy, setBusy] = useState(false);
  const [link, setLink] = useState("");
  const [copied, setCopied] = useState(false);

  const copy = async (url) => {
    try {
      await navigator.clipboard.writeText(url);
      setCopied(true);
      toast.success("Link copied to clipboard");
      setTimeout(() => setCopied(false), 2000);
    } catch {
      toast.info("Link ready — copy it from the box below");
    }
  };

  const share = async () => {
    if (link) return copy(link);
    setBusy(true);
    try {
      const { code } = await createShare(result, profile);
      const url = `${window.location.origin}/s/${code}`;
      setLink(url);
      await copy(url);
    } catch {
      toast.error("Could not create a share link. Please try again.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="relative">
      <button onClick={share} disabled={busy} data-testid="share-btn"
        className="inline-flex items-center gap-1.5 rounded-md border border-slate-300 bg-white px-4 py-2.5 text-sm font-semibold text-slate-700 shadow-sm transition-colors hover:bg-slate-50 disabled:opacity-60">
        {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <Share2 className="h-4 w-4" />} Share
      </button>
      {link && (
        <div className="absolute right-0 z-20 mt-2 w-[min(90vw,22rem)] rounded-lg border border-slate-200 bg-white p-3 shadow-lg" data-testid="share-popover">
          <p className="text-xs font-semibold text-slate-500">Anyone with this link can view this report (expires in 90 days)</p>
          <div className="mt-2 flex gap-2">
            <input readOnly value={link} data-testid="share-link-input" onFocus={(e) => e.target.select()}
              className="min-w-0 flex-1 rounded-md border border-slate-200 bg-slate-50 px-2.5 py-1.5 font-mono-tech text-xs text-slate-700" />
            <button onClick={() => copy(link)} data-testid="share-copy-btn"
              className="inline-flex items-center gap-1 rounded-md bg-[#0F172A] px-3 py-1.5 text-xs font-semibold text-white hover:bg-[#1E293B]">
              {copied ? <Check className="h-3.5 w-3.5" /> : <Copy className="h-3.5 w-3.5" />} {copied ? "Copied" : "Copy"}
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
